var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BasePayment",
    {
      attrs: {
        loading: _vm.loading,
        textHeader: _vm.$t("apps.payment.label.payservicepackage"),
        steps: _vm.progress.steps,
        active: _vm.progress.active,
        showBackButton: _vm.isShowBackButton
      }
    },
    [
      _vm.isPaymentFailed
        ? _c("PaymentFail", {
            on: {
              next: function() {
                return this$1.$router.push({ name: "Home" })
              }
            }
          })
        : [
            _vm.isStepOne
              ? _c("List", {
                  attrs: { detail: _vm.detail, totalNumber: _vm.totalNumber },
                  on: { next: _vm.onListClickedNext }
                })
              : _vm.isStepTwo
              ? _c("Confirm", {
                  attrs: {
                    detail: _vm.detail,
                    totalNumber: _vm.totalNumber,
                    isSubmitted: _vm.tabConfirm.isSubmitted,
                    paymentMethod: _vm.paymentMethod
                  },
                  on: {
                    prev: _vm.onConfirmClickedPrev,
                    next: _vm.onConfirmClickedNext
                  }
                })
              : _vm.isStepThree
              ? _c("Paid", {
                  attrs: { transaction: _vm.transaction },
                  on: { next: _vm.onPaidClickedNext }
                })
              : _vm._e()
          ],
      _vm._v(" "),
      _c("BaseModalScanPayment", {
        attrs: { id: _vm.MODAL_SCAN_PAYMENT, qrCodeUri: _vm.qrCodeUri }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34055ae4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34055ae4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentpackage/Invoice.vue
// module id = null
// module chunks = 